import React, { ReactNode } from 'react';
import { GoogleDetailedIcon } from '@fiverr-private/icons';

import { SocialButton } from '../SocialButton';
import { translate } from '../../utils/translate';
import { SocialProvider } from '../SocialButton/constants';
import { AuthenticationResponse } from '../../shared/constants/authenticationFlow';

interface GoogleButtonProps {
    children?: ReactNode;
    onSuccess?: (provider: SocialProvider, authenticationResponse: AuthenticationResponse) => void;
    onError?: (provider: SocialProvider, authenticationResponse: AuthenticationResponse) => void;
    onClick?: () => void;
}

export const GoogleButton = ({
    children = translate('social_buttons.continue_with_google'),
    onSuccess,
    onError,
    onClick,
}: GoogleButtonProps) => (
    <SocialButton
        SocialIcon={GoogleDetailedIcon}
        provider="google"
        onSuccess={onSuccess}
        onError={onError}
        onClick={onClick}
    >
        {children}
    </SocialButton>
);
